import { render, staticRenderFns } from "./StudyMedia.vue?vue&type=template&id=34fba004&"
import script from "./StudyMedia.vue?vue&type=script&lang=js&"
export * from "./StudyMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports